import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGrillaEspectaculos } from 'services/servicioGet';
import { ICaratulaEspectaculo } from 'utils/models/types';

interface EspectaculosState {
  grillaEspectaculos: ICaratulaEspectaculo[];
  loadingGrillaEspectaculos: boolean;
  errorGrillaEspectaculos: string | null;
}

const normalizarGrillaEspectaculos = (payload: unknown): ICaratulaEspectaculo[] => {
  if (Array.isArray(payload)) {
    return payload as ICaratulaEspectaculo[];
  }

  if (payload && typeof payload === 'object') {
    const candidate = (payload as { $values?: unknown; data?: unknown }).$values
      ?? (payload as { $values?: unknown; data?: unknown }).data;

    if (Array.isArray(candidate)) {
      return candidate as ICaratulaEspectaculo[];
    }
  }

  return [];
};

// Estado inicial del slice
const initialState: EspectaculosState = {
  grillaEspectaculos: [],
  loadingGrillaEspectaculos: false,
  errorGrillaEspectaculos: null,
};

// Thunk para obtener los espectáculos
export const fetchGrillaEspectaculos = createAsyncThunk<ICaratulaEspectaculo[], void, { rejectValue: string }>(
  'espectaculos/fetchGrillaEspectaculos',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getGrillaEspectaculos();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de grilla espectaculos
const espectaculosGrillaSlice = createSlice({
  name: 'grillaEspectaculos',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchGrillaEspectaculos.pending, state => {
        state.loadingGrillaEspectaculos = true;
        state.errorGrillaEspectaculos = null;
      })
      .addCase(fetchGrillaEspectaculos.fulfilled, (state, action) => {
        state.grillaEspectaculos = normalizarGrillaEspectaculos(action.payload);
        state.loadingGrillaEspectaculos = false;
      })
      .addCase(fetchGrillaEspectaculos.rejected, (state, action) => {
        state.loadingGrillaEspectaculos = false;
        state.errorGrillaEspectaculos = action.payload as string;
      });
  },
});

export default espectaculosGrillaSlice.reducer;
